import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { Place } from '../../models/serializable/place.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

/**
 * @deprecated Use {@link LocationComponent} instead.
 */
export class PlaceComponent extends Component {
  static readonly TYPE_ID: string = 'e209ed5dcc1144a89f45fb1507b0d10d';

  constructor(
    public readonly place: Place,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return PlaceComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PlaceComponent {
    return new PlaceComponent(
        context.fromData(MapUtils.get<SerializedData>(map, 'place')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'place': context.toData(this.place),
    };
  }

  clone(): this {
    return new PlaceComponent(
        this.place.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.place, this.place);
  }
}

export class PlaceComponentBuilder extends DataModelBuilder<PlaceComponent> {
  build(context: SerializationContext, map: SerializedData): PlaceComponent {
    return PlaceComponent.fromMap(context, map);
  }
}
